/**
 * Portal-Erkennung — PFAD-basiert (keine Subdomains).
 *
 * Die App nutzt vier Bereiche, jeweils unter einem festen Pfad:
 *   /portal           -> Mieterportal       (tenant)
 *   /eigentuemer      -> Eigentümerportal   (owner)
 *   /                 -> Verwalter-App      (super_admin/manager/...)
 *   /mandanten        -> Mandantenzentrale  (platform_admin)
 *
 * In früheren Versionen wurden Subdomains genutzt (portal.domivus.de,
 * eigentuemer.domivus.de, app.domivus.de, admin.domivus.de). Das wird
 * vom Emergent-Hosting mit Custom-Domain NICHT unterstützt, daher
 * ist jetzt alles pfad-basiert.
 */
export const PORTALS = {
  portal: { role: "tenant", label: "Mieterportal", redirect: "/portal" },
  eigentuemer: { role: "owner", label: "Eigentümerportal", redirect: "/eigentuemer" },
  app: { role: "staff", label: "Verwalter", redirect: "/" },
  admin: { role: "platform_admin", label: "Mandantenzentrale", redirect: "/mandanten" },
};

// Default-Portal wenn nichts matcht
const DEFAULT_PORTAL = "app";

/** Aus dem URL-Pfad das Portal ermitteln. */
function fromPath() {
  if (typeof window === "undefined") return null;
  const path = window.location.pathname || "/";
  if (path.startsWith("/portal")) return "portal";
  if (path.startsWith("/eigentuemer")) return "eigentuemer";
  if (path.startsWith("/mandanten")) return "admin";
  return null;
}

export function getCurrentPortal() {
  return fromPath() || DEFAULT_PORTAL;
}

export function isStaffPortal() {
  return getCurrentPortal() === "app";
}
export function isAdminPortal() {
  return getCurrentPortal() === "admin";
}
export function isTenantPortal() {
  return getCurrentPortal() === "portal";
}
export function isOwnerPortal() {
  return getCurrentPortal() === "eigentuemer";
}

/**
 * Returns true if the given user is allowed in the current portal.
 */
export function userMatchesPortal(user) {
  const p = getCurrentPortal();
  if (!user) return false;
  if (p === "admin") return user.role === "platform_admin";
  if (p === "portal") return user.role === "tenant";
  if (p === "eigentuemer") return user.role === "owner";
  // staff app
  return ["super_admin", "admin", "management", "manager", "accountant", "clerk"].includes(user.role);
}

/**
 * Where should this user be sent after login?
 */
export function landingForUser(user) {
  if (!user) return "/login";
  if (user.role === "platform_admin") return "/mandanten";
  if (user.role === "tenant") return "/portal";
  if (user.role === "owner") return "/eigentuemer";
  return "/";
}

/**
 * Liefert die interne URL für ein Portal (gleicher Host, anderer Pfad).
 */
export function urlForPortal(portalKey) {
  const cfg = PORTALS[portalKey];
  return (cfg && cfg.redirect) || "/";
}
